export class NotFoundError extends Error {
    readonly endpoint: string;

    constructor(endpoint: string, message?: string) {
        super(message ?? `Resource not found: ${endpoint}`);
        this.name = 'NotFoundError';
        this.endpoint = endpoint;
        // CRA/Babel down-levels `extends Error` to an ES5 target, which breaks the
        // prototype chain; restore it so `instanceof NotFoundError` works.
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
